module.exports = __webpack_public_path__ + "img/loan_summ_icon.3d1a6460.svg";